import { userService } from '../../services/auth-api.service.js'
import router from '../../router.js'

// const user = JSON.parse(localStorage.getItem('user'));
const user = null
const authenticationInitialState = user
  ? { status: { loggedIn: true }, user,errorMessage: '' }
  : { status: {}, user: null,errorMessage: '' }
  
export const authenticationModule = {
  namespaced: true,
  state: authenticationInitialState,
  getters: {
    getErrors: state => state.errorMessage
  },
  actions: {
    login ({ dispatch, commit }, { resellerId, username, password, returnurl }) {
      commit('resetError');
      commit('loginRequest', { resellerId, username })

      userService.login(resellerId, username, password)
        .then(
          user => {
            commit('loginSuccess', user)

            if (returnurl) {
              router.push(returnurl)
            } else {
              router.push('/')
            }
          },
          error => {
            commit('loginFailure', error)
            dispatch('alert/error', error, { root: true })
          }
        )
    },
    register ({ dispatch, commit }, { resellerId, username, autoLogin, returnurl }) {
      commit('resetError');
      commit('registerRequest', { resellerId, username })

      return userService.register(resellerId, username, autoLogin)
        .then(
          user => {
            if (autoLogin && autoLogin === true) {
              commit('registerLoginSuccess', user)
            }
            commit('registerSuccess', user)

            if (returnurl) {
              router.push(returnurl)
            } else {
              router.push('/')
            }
          },
          error => {
            commit('registerFailure', error)
            dispatch('alert/error', error, { root: true })
          }
        )
    },
    logout ({ dispatch, commit }) {
      commit('resetError');
      // userService.logout();
      dispatch('resetStore', null, { root: true })
      commit('logout')
    },
    resetPassword ({ dispatch, commit }, { resellerId, username }) {
      commit('resetError');
      userService.resetPassword(resellerId, username)
        .then(
          user => {            
            router.push('/login')
          },
          error => {throw Error(error)}
        ).catch(err => {           
          commit('displayError', 'Please check the details entered.')
        });
    },
    changePassword ({ dispatch, commit }, { resellerId, username, password, newPassword }) {
      userService.changePassword(resellerId, username, password, newPassword)
        .then(
          user => {
            router.push('/myclaims')
          },
          error => {}
        )
    },
    resetErrorMessage ({commit}) {
      commit('resetError', '')
    }
  },
  mutations: {
    registerRequest (state, user) {
      state.status = { registering: true }
      state.user = user
    },
    registerSuccess (state, user) {
      state.status = { registered: true }
      state.user = user
    },
    registerLoginSuccess (state, user) {
      state.status = { registered: true, loggedIn: true }
      state.user = user
    },
    registerFailure (state) {
      state.status = {}
      state.user = null
    },
    loginRequest (state, user) {
      state.status = { loggingIn: true }
      state.user = user
    },
    loginSuccess (state, user) {
      state.status = { loggedIn: true }
      state.user = user
    },
    loginFailure (state) {
      state.status = { failure: true }
      state.user = null
    },
    logout (state) {
      state.status = {}
      state.user = null
    },
    displayError (state, error) {
      state.errorMessage = error
    },
    resetError (state) {
      state.errorMessage = ''
    }
  }
}
